import {
  unionCmd,
  ctrlDtu,
  getRecTimer,
  setDeviceAzimuth,
  testSdmpro,
} from '@/api';

const actions = {
  async ctrlDtu(context, { deviceId, cmd, cmdOptions }) {
    const res = await ctrlDtu({ deviceId, cmd, cmdOptions });
    if (res.data.code !== 0) throw new Error(res.data.msg);
    return res.data.msg;
  },
  async getRecTimer(context, { deviceId }) {
    const res = await getRecTimer({ deviceId });
    if (res.data.code !== 0) throw new Error(res.data.msg);
    const match = /^HUASI,GET,NODE,TIMER,([\w|,|.]+),OK$/.exec(res.data.timer);
    return match[1];
  },
  async setAzimuth(context, { deviceId, payload }) {
    const res = await setDeviceAzimuth({ payload, id: deviceId });
    if (res.data.code !== 0) throw new Error(res.data.msg);
    return res.data.recMsg;
  },
  async unionCmd(context, { deviceId, cmd, payload }) {
    const res = await unionCmd({ deviceId, cmd, payload });
    if (res.data.code !== 0) throw new Error(res.data.msg);
    return res.data.msg;
  },
  async testSdmpro(context, { register, cmd, payload }) {
    const res = await testSdmpro({ register, cmd, payload });
    if (res.data.code !== 0) throw new Error(res.data.msg);
    return res.data.msg;
  },
};

export default {
  actions,
  namespaced: true,
};

